import React from "react";

function LinkIcon(props) {
  return (
    <a  target="_blank" href={props.href}>
      {props.group_name}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
      >
        <path
          stroke="#626F7F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.8"
          d="M6.938 3.563H5.063a1.5 1.5 0 00-1.5 1.5v7.875a1.5 1.5 0 001.5 1.5h7.875a1.5 1.5 0 001.5-1.5v-1.876m0-4.124V3.563h-3.376m3.188.187L8.812 9.188"
        ></path>
      </svg>
    </a>
  );
}

export default LinkIcon;
